<div style="position:relative" class="pt-5">
  <div class="container__badge" *ngIf="sku.badge">
    POPULAR CHOICE
  </div>
  <div class="sku__container" [ngClass]="{ border_badge: sku.badge }">
    <div class="sku__title">
      {{ sku.name }}
    </div>
    <div class="sku__description">
      {{ sku.description }}
    </div>
    <div class="sku__features" style="padding-bottom:50px;">
      <div style="padding-bottom:20px">
        <span [ngStyle]="{
          color:
            sku.features_available.length === 0 &&
            sku.features_unavailable.length === 0
              ? 'grey'
              : 'black'
        }">Features</span>
      </div>
      <div class="sku__features__available" *ngFor="let avail of sku.features_available">
        <div class="sku__features__single">
          <mat-icon>check</mat-icon>
          <span> {{ avail.name }}</span>
        </div>
      </div>
      <ng-container *ngIf="sku.features_unavailable.length > 0">
        <div class="sku__features__notavailable" *ngFor="let avail of sku.features_unavailable">
          <div class="sku__features__single">
            <mat-icon style="margin-right:5px;color:grey">close</mat-icon>
            <span style="color:grey">{{ avail.name }}</span>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="mt-4 text-center mb-4">
      <button class="btn btn-primary" (click)="activePlan()" *ngIf="skuId!==sku.sku_id">
        Available Plans
      </button>
      <button class="btn btn-primary" style="background-color:#0081B2!important" (click)="activePlan()" *ngIf="skuId===sku.sku_id">
        Available Plans
      </button>
    </div>
  </div>
  <div class="arrow_container">
    <div class="arrow"></div>
  </div>
</div>
